/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { findIndex, get, isEmpty } from "lodash";
import { getCardSalesList } from "../../../../apis/finances/cards";
import { ControlTable } from "../../../../components/Table";
import { getParams } from "../../../../utils/params";
import CategoryMappingModal from "../../../../components/Bank/CategoryMappingModal";
import useForm from "../../../../hooks/useForm";
import IconButton from "../../../../components/Button/IconButton";
import DeleteIcon from "../../../../assets/images/icon/delete-icon-01.svg";
import systemAlert from "../../../../utils/systemAlert";
import { deleteAccountingTitle } from "../../../../apis/finances/accounting-title";
import SalesDetail from "./SalesDetail";
import { useSelector } from "react-redux";
import Icon from "../../../../components/Icon";
import CommentIcon from "../../../../assets/images/icon/comment-icon.svg"

const SalesSummaries = ({ data }) => {
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const [sortFields, setSortFields] = useState([
    { key: "trDate", order: 'desc' },
    { key: "buyAmt", order: '' },
    { key: "payAmt", order: '' },
  ])
  const [fields, setFields] = useState([]);
  const [isCategoryMappingOpen, setIsCategoryMappingOpen] = useState(false)
  const [detailOpen, setDetailOpen] = useState(false)
  const [detailData, setDetailData] = useState({})
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions)) {
      setTargetPermission(permissions.find(p => p.code === 'FUND_CARD_HISTORY'))
    }
  }, [permissions])

  useEffect(() => {
    if (!isEmpty(targetPermission)) {
      setFields([
        { title: "거래일자", key: "trDate", type: "date", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
        { title: "결제금액", key: "buyAmt", type: "comma", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
        { title: "지급금액", key: "payAmt", type: "comma", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
        {
          title: '',
          key: 'comments',
          onValue: (value) => {
            return (
              !isEmpty(value) ? (
                <>
                  <Icon src={CommentIcon} />
                  <span className="ml-4 font-bold">{value.count}</span>
                </>
              ) : (<></>)
            )
          }
        },
        {
          title: '카테고리',
          key: 'accountingTitleUses',
          onValue: (value) => {
            return (
              !isEmpty(value) &&
              value.map((category, idx) => (
                <div className="text-align-right" key={idx}>
                  <p className="pt-8 pb-8">
                    <span className="vertical-middle">{category.accountingTitle.name}</span>
                    {targetPermission.level > 1 && (
                      <IconButton className="ml-4 vertical-middle" icon={DeleteIcon} action={() => handleRemoveCategory(category)} />
                    )}
                  </p>
                </div>
              ))
            )
          }
        }
      ])
    }
  }, [targetPermission, sortFields])

  const {
    form,
    setSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    setOrderBy
  } = useForm(
    {
      payDate: data.payDate,
      cardCompany: data.cardCompany,
      order: [
        {
          trDate: 'desc'
        },
      ],
      page: 0,
      limit: 10
    },
  )


  useEffect(() => {
    const sortField = sortFields.find((field) => !isEmpty(field.order))
    if (sortField) {
      setOrderBy(sortField)
    }
  }, [sortFields])

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, []);

  const submit = (params) => {
    setIsLoading(true);
    getCardSalesList(getParams(params))
      .then((res) => {
        const { totalCount, cardSalesList, comment } = res.data
        const transList = cardSalesList.map((invoice) => ({
          ...invoice,
          comments: comment.listByPost.find(c => c.postIdx === invoice.idx) || {}
        }))
        setTotal(totalCount);
        setList(transList);
      })
      .catch(() => { })
      .finally(() => setIsLoading(false));
  };

  const rowBtnConfig = {
    title: '카테고리 매핑',
    rowButtons: [
      {
        type: "edit",
        className: "mr-4",
        action: (data) => {
          setSelectedList([data])
          setIsCategoryMappingOpen(true)
        },
      },
    ],
  };

  const handleRemoveCategory = (category) => {
    systemAlert(`매핑된 카테고리(${category.accountingTitle.name})를 삭제하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            deleteAccountingTitle(category.idx)
              .then(() => {
                filterSubmit();
              })
              .catch(() => { })
              .finally(() => { })
          }
        }
      ]
    })
  }

  const handleRowClick = (data, e) => {
    if (e.target.tagName !== 'TR' && e.target.tagName !== 'TD') return
    setDetailData(data)
    setDetailOpen(true)
  }

  const handleSort = (key) => {
    const sortField = sortFields.find(field => field.key === key)
    const idx = findIndex(sortFields, sortField)
    let newArray = [...sortFields.map((field) => ({
      ...field,
      order: field.key !== key ? '' : field.order
    }))]
    newArray[idx] = {
      key,
      order: newArray[idx].order !== 'desc' ? 'desc' : 'asc'
    }
    setSortFields(newArray)
  }

  const orderKey = (key) => {
    const sortField = sortFields.find(field => field.key === key)
    return sortField.order
  }


  return (
    !isEmpty(targetPermission) && (
      <>
        <div className="collapsible-table-container">
          <div className="collapsible-table-inner-title">
            <p className="first-title">총 거래건수</p>
            <p className="second-title">
              <span className="anjsep">{get(data, "trCount")}</span> 건
            </p>
          </div>
          <div className="collapsible-table-inner-contents">
            <ControlTable
              isLoading={isLoading}
              fields={fields}
              sortField={sortFields.find((field) => !isEmpty(field.order))}
              list={list}
              page={page}
              setPage={setPage}
              limit={limit}
              setLimit={setLimit}
              total={total}
              rowBtn={targetPermission && targetPermission.level > 1 ? rowBtnConfig : {}}
              onSelect={handleRowClick}
            />
          </div>
        </div>
        {isCategoryMappingOpen && (
          <CategoryMappingModal
            open={isCategoryMappingOpen}
            setOpen={setIsCategoryMappingOpen}
            selectedItem={selectedList}
            setSelectedItem={setSelectedList}
            useType="card_sales"
            submit={filterSubmit}
          />
        )}
        {detailOpen && (
          <SalesDetail
            open={detailOpen}
            setOpen={setDetailOpen}
            data={detailData}
            permission={targetPermission}
            submit={filterSubmit}
          />
        )}
      </>
    )
  );
};

export default SalesSummaries;
